import { useSelector } from 'react-redux';
import { colors, Surface, Txt } from '@vst/beam';

import { selectChangePlan } from '@app/redux/changePlan';

import { Variant } from '../../types';

import styles from './styles.module.scss';

type PlanCardProps = {
  variant?: Variant;
  children: React.ReactNode;
  name: string;
  broadbandLabel?: React.ReactNode;
};

const PlanCard = ({ variant = Variant.DEFAULT, children, name, broadbandLabel }: PlanCardProps) => {
  const { hideBroadbandLabels } = useSelector(selectChangePlan);

  return (
    <Surface className={`${styles['container']} ${styles[variant]}`} data-cy="plan-card-surface">
      <Surface data-cy="plan-card-header" className={styles['header']} py="4px">
        <Txt variant="labelMedium" style={{ color: name === '-' ? colors.blue['100'] : 'inherit' }}>
          {name}
        </Txt>
      </Surface>
      <Surface
        style={{
          paddingBottom: broadbandLabel && hideBroadbandLabels ? '0px' : undefined,
        }}
        className={styles['body']}
      >
        {children}
        {broadbandLabel && (
          <Surface
            data-selector="broadband-label"
            data-hidden={hideBroadbandLabels ? 'true' : undefined}
            style={{
              position: 'relative',
              height: hideBroadbandLabels ? '88px' : undefined,
              overflow: 'hidden',
            }}
          >
            {hideBroadbandLabels && <Surface className={styles['overlay']} />}
            {broadbandLabel}
          </Surface>
        )}
      </Surface>
    </Surface>
  );
};

export default PlanCard;
